import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { useAxiosRefreshToken } from './hooks'
import { CookieUtil } from './util'
import { COOKIE_AUTO_LOGIN } from './constants/cookie'
import ReactGA from 'react-ga'

const gaTrackingId = process.env.REACT_APP_GA_TRACKING_ID
ReactGA.initialize( gaTrackingId, { debug: true } )

const queryClient = new QueryClient()
const root = ReactDOM.createRoot( document.getElementById( 'root' ) )

const onToken = async () => {
    let token = ''
    try {
        if( CookieUtil.getCookie( COOKIE_AUTO_LOGIN ) !== 'Y' ) throw new Error()
        token = await useAxiosRefreshToken()
    } finally{
        root.render(
            <React.StrictMode>
                <QueryClientProvider client={ queryClient }>
                    {/* <ReactQueryDevtools initialIsOpen={ true } /> */}
                    <App accessToken={ token }/>
                </QueryClientProvider>

            </React.StrictMode>
        )

        reportWebVitals()
    }

}

onToken()

